import React from 'react';
import cl from "../BaseSimplePage/BaseSimpleItemBrowserItem.module.css";

const SurveysItemBrowserItem = ({id, title, subtitle, uptitle, selected, onClick, style}) => {
    return (
        <div style={style}>
            <button
                className={selected ? `${cl.buttonMain} ${cl.buttonSelected}` : cl.buttonMain}
                onClick={onClick}
            >
                <p className={cl.id}>{id}</p>
                <div className={cl.titleArea}>
                    <div className={cl.titleBlock}>
                        {uptitle && <p className={cl.uptitle}>{uptitle}</p>}
                        <p className={cl.title}>{title}</p>
                        {subtitle && <p className={cl.subtitle}>{subtitle}</p>}
                    </div>
                </div>
            </button>
        </div>
    );
};

export default SurveysItemBrowserItem;